import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/main.vue'
import Login from '../views/login/index.vue'

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

// replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Main',
		component: Main,
		meta:{noNav:true},
		directory:false,
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			noNav:true
		},
		directory:false,
	},	
	{
		path: '/replace',
		name: 'Replace',
		component: ()=>import('@/views/replace.vue'),
		meta: {
			noNav:true
		},
		directory:false,
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import('@/views/dashboard/index.vue'),
		meta: {
			id:1,
			title: '仪表盘',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-odometer',
		},
		directory:true
	},
	{
		path: '/customerManage',
		name: 'CustomerManage',
		component: () => import('@/views/customerManage/index.vue'),
		meta: {
			id:2,
			title: '客户管理',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-user',
		},
		directory:true
	},
	{
		path: '/cardPwdManage',
		name: 'CardPwdManage',
		component: () => import('@/views/cardPwdManage/index.vue'),
		meta: {
			id:3,
			title: '产品管理',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-s-shop',
		},
		directory:true
	},
	{
		path: '/orderManage',
		name: 'OrderManage',
		component: () => import('@/views/orderManage/index.vue'),
		meta: {
			id:4,
			title: '提卡订单',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-document',
		},
		directory:true
	},
	{
		path: '/writeOffOrder',
		name: 'WriteOffOrder',
		component: () => import('@/views/orderManage/writeOff.vue'),
		meta: {
			id:4,
			title: '核销订单',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-document',
		},
		directory:true
	},
	// {
	// 	path: '/cardPwdQuery',
	// 	name: 'CardPwdQuery',
	// 	component: () => import('@/views/cardPwdQuery/index.vue'),
	// 	meta: {
	// 		id:4,
	// 		title: '卡密查询',
	// 		leven:0,
	// 		parentId:0,
	// 		islink:true,
	// 	},
	// 	directory:true
	// },
	{
		path: '/Setting',
		name: 'Setting',
		component: () => import('@/views/setting/index.vue'),
		meta: {
			id:6,
			title: '系统设置',
			leven:0,
			parentId:0,
			islink:false,
		},
		directory:true
	},
	{
		path: '/childAccount',
		name: 'ChildAccount',
		component: () => import('@/views/setting/index.vue'),
		meta: {
			id:61,
			title: '子账户设置',
			leven:1,
			parentId:6,
			islink:true,
			icon:'el-icon-user-solid',
		},
		directory:true
	},{
		path: '/whiteList',
		name: 'WhiteList',
		component: () => import('@/views/setting/whiteList.vue'),
		meta: {
			id:61,
			title: '核销白名单',
			leven:1,
			parentId:6,
			islink:true,
			icon:'el-icon-s-order',
		},
		directory:true
	},
	{
		path: '/operationLogs',
		name: 'OperationLogs',
		component: () => import('@/views/setting/operationLogs.vue'),
		meta: {
			id:62,
			title: '操作日志',
			leven:1,
			parentId:6,
			islink:true,
			icon:'el-icon-s-order',
		},
		directory:true
	},
	{
		path: '/resetPassword',
		name: 'ResetPassword',
		component: () => import('@/views/setting/resetPassword.vue'),
		meta: {
			id:63,
			title: '重置密码',
			leven:1,
			parentId:6,
			islink:true,
			icon:'el-icon-lock'
		},
		directory:true
	}
]

const router = new VueRouter({
	linkActiveClass: "activeClass",
	/*添加默认样式 activeClass   activeClass 写在组件样式里面   */
	routes
})

export default router
